// Package Imports
import { useTranslate } from '@refinedev/core';
import { Row, Col, Form, Button, Switch, Card } from 'antd';
import { useEffect, useState } from 'react';
// Project Imports
import ComponentToRender from 'pages/unificationList/ComponentToRender';
import { useWatch } from 'antd/es/form/Form';
import useStatusDropdown from 'pages/unificationList/dropDownDummy';
import DropdownInput from 'components/dropdown/dropDownInput';
import { useSimpleList } from '@refinedev/antd';
import apiEndpoint from 'core/common/apiEndPoints';
import getTimeLineDropdownList from 'core/utils/getTimeLineValue';
import extractFrequencyName from 'pages/unificationList/utils/extractFrequencyName';

const Filter = ({
  formProps,
  setFilters,
  frequencyName,
  setFrequencyName,
  timelineType,
  setTimelineType,
  frequencyType,
  setFrequencyType,
}) => {
  const { form } = formProps;
  const t = useTranslate();
  const { statusDropdown } = useStatusDropdown();
  const [showComponent, setShowComponent] = useState(null);
  const onReset = async () => {
    form?.resetFields();
    setFilters([], 'replace');
    setFrequencyName('');
    setShowComponent(null);
  };

  const frequencyId = useWatch('frequency', {
    form,
    preserve: true,
  });

  const date = useWatch('date', {
    form,
    preserve: true,
  });

  const { listProps } = useSimpleList({
    resource: `${apiEndpoint.programConfigDetails}`,
    dataProviderName: 'programDataProvider',
    pagination: {
      mode: 'off',
    },
  });
  const frequencyOptionList = (listProps?.dataSource as any)?.results;

  // get unique frequency name from frequency list
  const uniqueFrequencyIds = new Set();
  const uniqueFrequencyOptionList = frequencyOptionList?.filter((item) => {
    if (!uniqueFrequencyIds.has(item.frequency_id)) {
      uniqueFrequencyIds.add(item.frequency_id);
      return true;
    }
    return false;
  });

  const { listProps: timelineData } = useSimpleList({
    resource: `${apiEndpoint.paymentProcessTimeline}/?frequency_id=${frequencyId}`,
    dataProviderName: 'paymentDataProvider',
    queryOptions: { enabled: !!frequencyId },
    pagination: {
      mode: 'off',
    },
  });
  const timelineResponse = (timelineData?.dataSource as any)?.results;

  const onSelectFrequency = () => {
    setShowComponent(null);
  };

  useEffect(() => {
    let frequencyNameData = extractFrequencyName(
      frequencyId,
      uniqueFrequencyOptionList,
      'name'
    );
    const frequencyTypeData = extractFrequencyName(
      frequencyId,
      uniqueFrequencyOptionList,
      'type'
    );
    frequencyNameData = frequencyNameData?.trim()?.toLowerCase();
    if (frequencyNameData !== frequencyName) {
      setFrequencyName(frequencyNameData);
      setFrequencyType(frequencyTypeData);
    }
    if (uniqueFrequencyOptionList?.length === 1) {
      const value = uniqueFrequencyOptionList?.[0]?.frequency_id;
      form.setFieldValue('frequency', value);
    }
  }, [uniqueFrequencyOptionList]);
  const timeLineDropdownList = frequencyId
    ? getTimeLineDropdownList(timelineResponse, frequencyType)
    : [];
  useEffect(() => {
    if (uniqueFrequencyOptionList?.length === 1 && frequencyId) {
      setFilters([
        {
          field: 'frequency_id',
          operator: 'contains',
          value: frequencyId,
        },
      ]);
    }
  }, [frequencyId]);
  useEffect(() => {
    if (timelineType && timeLineDropdownList?.length === 1) {
      form.setFieldValue('date', timeLineDropdownList?.[0]?.value);
    }
  }, [timeLineDropdownList]);
  useEffect(() => {
    if (timelineType && timeLineDropdownList?.length === 1 && date) {
      setFilters([
        {
          field: 'date',
          operator: 'contains',
          value: date,
        },
      ]);
    }
  }, [date]);
  return (
    <Card className="mt-5 mb-6">
      <Form
        layout="vertical"
        {...formProps}
        // className="border px-4 bg-white pt-6 pb-4 mt-4 rounded-lg"
      >
        <Row gutter={[24, 0]}>
          <Col xs={24} sm={24} lg={4}>
            <DropdownInput
              label={t('common.frequency')}
              name="frequency"
              placeholder={t('placeholder.frequency')}
              message={t('errorMessages.selectFrequencyMsg')}
              optionList={uniqueFrequencyOptionList?.map((item) => ({
                label: `${item?.frequency_name} `,
                value: item?.frequency_id,
              }))}
              onChange={() => onSelectFrequency()}
              values={form?.getFieldValue('frequency')}
            />
          </Col>

          <Col xs={24} sm={24} lg={7}>
            <Switch
              checked={timelineType}
              onChange={(e) => {
                setTimelineType(e);
                form.setFieldValue('date', null);
              }}
              checkedChildren="Select"
              unCheckedChildren="Enter"
              className="z-10 w-[80px] absolute right-4"
            />
            {timelineType ? (
              <DropdownInput
                label={t('common.period')}
                name="date"
                optionList={timeLineDropdownList}
                disabled={!form?.getFieldValue('frequency')}
                className="relative"
                values={date}
                placeholder={t('placeholder.timeline')}
              />
            ) : (
              <ComponentToRender
                frequencyType={frequencyType}
                setShowComponent={setShowComponent}
                showComponent={showComponent}
                disabled={!formProps.form?.getFieldValue('frequency')}
                date={date}
              />
            )}
          </Col>
          <Col xs={24} sm={24} lg={5}>
            <DropdownInput
              label={t('payoutHistory.payoutTableHeaders.status')}
              name="status"
              message={t('payoutHistory.messages.status')}
              placeholder={t('payoutHistory.messages.status')}
              optionList={statusDropdown}
              values={form?.getFieldValue('status')}
            />
          </Col>
        </Row>
        <Row className="justify-end gap-4">
          <Button onClick={onReset} className="btn-width">
            {t('buttons.reset')}
          </Button>
          <Button htmlType="submit" type="primary" className="btn-width">
            {t('buttons.apply')}
          </Button>
        </Row>
      </Form>
    </Card>
  );
};
export default Filter;
